import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { PersonSwingIllustration, cn } from '@restworld/utils-common';
import { Heading } from '@restworld/ui-ds-base';
import { Button } from '@restworld/ui-ds-base';

export const CoverLetterConfirmation = ({
  onWriteCoverLetter,
  onApplyWithoutCoverLetter,
  loading,
  variant,
}: {
  onWriteCoverLetter: () => void;
  onApplyWithoutCoverLetter: () => void;
  loading: boolean;
  variant?: 'one' | 'two';
}) => {
  const { t } = useTranslation('onboarding-page');
  return (
    <div className="flex flex-col gap-10 text-center items-center w-full">
      <SecondWrapperDiv isReversed={variant === 'two'}>
        <PersonSwingIllustration
          {...{
            width: 320,
            height: 260,
          }}
        />
        <div className="flex flex-col gap-2 max-w-sm">
          <Heading size={4} weight="semibold" className="leading-6.75">
            {t('launch_yourself_with_a_great_cover_letter')}
          </Heading>
          <Heading size={5} weight="normal" color="muted" className="leading-6">
            {t('the_cover_letter_shows_interest_and_professionalism')}
          </Heading>
        </div>
      </SecondWrapperDiv>
      <div className="flex flex-col gap-2 w-full">
        <Button onClick={onWriteCoverLetter} variant="primary" fullwidth>
          {t('write_the_cover_letter')}
        </Button>
        <Button onClick={onApplyWithoutCoverLetter} variant="tertiary" fullwidth loading={loading}>
          {t('candidates_without_letter')}
        </Button>
      </div>
    </div>
  );
};
const SecondWrapperDiv = ({ isReversed, className, ...props }: any) => (
  <div
    className={cn(
      'flex flex-col gap-10 text-center items-center',
      isReversed ? 'flex-col-reverse' : 'flex-col',
      className
    )}
    {...props}
  />
);
